import * as React from "react";
import { ajax } from "jquery";

class Translate extends React.Component{
    mounted = false;
    constructor(props) {
        super(props);
        this.mounted = false;

        this.state = {
            loadSuccess: false
        }

        this.Resource;
    }

    getValue(key) {
        let result = this.Resource;
        let arrayKey = key.split(".");
        for (let i = 0; i < arrayKey.length; i++) {
            result = result[arrayKey[i]];
        }

        if (typeof result != "string") {
            return key;
        }

        return result;
    }

    render() {
        if (this.state.loadSuccess) {
            return (<div>{this.props.children}</div>);
        }

        return <div>結果取得中...</div>;
    }

    componentDidMount() {
        this.mounted = true;
        var url = document.getElementById("languageUrl").getAttribute("value").valueOf();
        ajax({
            url: url,
            type: 'GET',
            credentials: 'same-origin'
        }).done((json) => {
            if (this.mounted) {
                this.Resource = json;
                this.setState({ loadSuccess: true });
                this.props.handlerLoad();
            }
        });
    }
    componentWillUnmount(){
        this.mounted = false;
    }
}

export default Translate;


// WEBPACK FOOTER //
// ./components/common/translate/index.jsx